import { useState, useEffect } from 'react';
import axios from 'axios';
import { setStoreTimezone } from '../utils/datetime';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cachedSettings = null;
let cachedPromise = null;
const listeners = new Set();

export function refreshCompanySettings() {
  cachedSettings = null;
  cachedPromise = null;
  return loadCompanySettings();
}

export function loadCompanySettings() {
  if (cachedSettings) return Promise.resolve(cachedSettings);
  if (cachedPromise) return cachedPromise;
  cachedPromise = axios
    .get(`${API}/settings/company`, { withCredentials: true })
    .then((r) => {
      cachedSettings = r.data;
      if (r.data && r.data.timezone) setStoreTimezone(r.data.timezone);
      listeners.forEach((cb) => cb(cachedSettings));
      return cachedSettings;
    })
    .catch(() => {
      // NÃO cacheia o fallback — assim a próxima chamada (após login) refaz
      const fallback = { trade_name: 'Smart Flow' };
      listeners.forEach((cb) => cb(fallback));
      return fallback;
    })
    .finally(() => {
      cachedPromise = null;
    });
  return cachedPromise;
}

export function useCompanySettings() {
  const [settings, setSettings] = useState(cachedSettings);

  useEffect(() => {
    if (!cachedSettings) {
      loadCompanySettings().then((s) => setSettings(s));
    }
    const cb = (s) => setSettings(s);
    listeners.add(cb);
    return () => listeners.delete(cb);
  }, []);

  return settings || { trade_name: 'Smart Flow' };
}
